import { twMerge } from "tailwind-merge";
import { PageContainer } from "~/components/pageContainer/PageContainer";
import { Card, Spinner, SpinnerContainer } from "@sellar-io/components";
import { ReactElement } from "react";
import { useNavigate } from "react-router";
import { ErrorMessage } from "~/components/errorMessage/ErrorMessage";
import { NavigationBar } from "~/components/navigation/NavigationBar";
import { BUSINESS } from "~/constants/routes";
import { BusinessFormUpdate } from "~/forms/business/BusinessFormUpdate";
import { apiV2AssertError } from "~/hooks/api/v2/apiV2Request";
import { useBusiness } from "~/hooks/api/v2/business/useBusiness";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";

export function BusinessEditSettings(): ReactElement {
  const { business } = useSellarCurrentBusiness();
  const navigate = useNavigate();

  if (!business) throw new Error("Cannot find business");

  const businessQuery = useBusiness(
    business.id,
    {
      enabled: Boolean(business.id),
      staleTime: 1000 * 60 * 5,
    },
    "scope:edit-business-details",
  );

  return (
    <>
      <NavigationBar
        title={"Edit Business Details"}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => navigate(BUSINESS)}
      />
      {businessQuery.isFetching ? (
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      ) : businessQuery.isError ? (
        <ErrorMessage>
          {apiV2AssertError(businessQuery.error)?.response?.data.message ??
            "Unknown error"}
        </ErrorMessage>
      ) : businessQuery.isSuccess ? (
        <PageContainer>
          <Card className={twMerge("bg-white", "p-5 md:p-6")}>
            <BusinessFormUpdate
              business={businessQuery.data}
              onUpdate={() => {}}
            />
          </Card>
        </PageContainer>
      ) : null}
    </>
  );
}
